// extracted by mini-css-extract-plugin
export default {"title":"vba-z","warning":"wba-z","sizeOptionsLegendText":"xba-z"};